import { get } from 'lodash';

const root = state =>
  get(state, 'Provision2BaseRatesSetupState.provision2BaseRatesSetup');
export const getLoading = state => get(root(state), 'loading');
export const getGridDataLunch = state => get(root(state), 'gridDataLunch');
export const getGridDataBreakfast = state =>
  get(root(state), 'gridDataBreakfast');
export const getSiteId = state => get(root(state), 'siteId');
export const getFiscalYears = state => get(root(state), 'fiscalYears');
export const getSiteData = state => get(root(state), 'siteData');
export const getFiscalYear = state => get(root(state), 'fiscalYear');
export const getSaveSuccessful = state => get(root(state), 'saveSuccessful');
export const getOtherFiscalYear = state => get(root(state), 'otherFiscalYear');
export const getOtherFiscalYears = state =>
  get(root(state), 'otherFiscalYears');
export const getShowUseAnotherFiscalYear = state =>
  get(root(state), 'showUseAnotherFiscalYear');



// WEBPACK FOOTER //
// ./src/pages/provision2baseratessetup/state/provision2BaseRatesSetup/selectors.js